export default __webpack_public_path__ + "static/media/ofline-white.bb61b804.svg";